import React from 'react';
import { useSession } from '../../contexts/SessionContext';
import AIFilingPage from '../AIlFiling';
import SgAllFilingPage from './SgAllFiling';

const CountryBasedFilingRoute: React.FC = () => {
  const { activeOrg, loading } = useSession();

  // Show loading while session is loading
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <svg className="animate-spin h-12 w-12 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p className="text-gray-600 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  // Route based on country_iso
  // If country is Singapore (SG), show Singapore version
  // Otherwise, show Malaysia (MY) or default version
  if (activeOrg?.countryIso === 'SG') {
    return <SgAllFilingPage />;
  } else {
    // Default to Malaysia version (or other countries)
    return <AIFilingPage />;
  }
};

export default CountryBasedFilingRoute;